import { UserV2 } from "@towersystems/roam-common/lib/generated-types";

export const userIsAdmin = (user: UserV2) => {
  return Boolean(user.roles.find((i) => i.code === "store-owner"));
};
